import { SpacerComponent } from '@components/Spacer';
import { Button1Text } from './web/texts/Texts';

export default function ProgressNotSavedModalComponent({
  handleDismiss,
  handleQuit,
}: {
  handleDismiss: () => void;
  handleQuit: () => void;
}) {
  return (
    <div
      onClick={handleDismiss}
      aria-hidden="true"
      className="fixed bottom-0 left-0 top-0 z-[100] flex w-[100%] items-center justify-center bg-product-background-overlay-dark"
    >
      <div
        aria-hidden="true"
        className="relative flex w-[95%] max-w-[500px] flex-col items-center rounded-md bg-product-background-secondary-dark px-6 pb-8 pt-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-center text-2xl font-bold text-product-text-primary-dark">
          Are you sure you want to quit?
        </h2>
        <SpacerComponent className="h-2"></SpacerComponent>
        <p className="max-w-sm text-center text-base text-product-text-secondary-dark">
          All progress in this session will be lost
        </p>
        <SpacerComponent className="h-8"></SpacerComponent>
        <button
          onClick={handleDismiss}
          className={`flex w-full justify-center rounded-xl border-2 border-transparent bg-product-button-primary-enabled-dark px-4 py-2 text-product-text-primary-dark hover:bg-product-button-primary-hovered-dark focus:outline-none`}
        >
          <Button1Text>Stay</Button1Text>
        </button>
        <SpacerComponent className="h-4"></SpacerComponent>
        <button
          onClick={handleQuit}
          className={`flex w-full justify-center rounded-xl border-2 border-product-button-secondary-enabled-dark px-4 py-2
          text-product-text-primary-dark hover:bg-product-button-secondary-hovered-dark/30 focus:outline-none`}
        >
          <Button1Text>Quit</Button1Text>
        </button>
      </div>
    </div>
  );
}
